// extracted by mini-css-extract-plugin
export default {"icon":"ZHbn","title":"_6nBl"};